import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export function RequireAuth({ children }) {
    const { user, loading } = useAuth();
    const loc = useLocation();
    if (loading) {
        return (
            <div
                data-testid="auth-loading"
                className="grid min-h-screen place-items-center bg-background text-zinc-500"
            >
                <div className="flex items-center gap-3">
                    <div className="h-2 w-2 animate-pulse rounded-full bg-brand-red" />
                    <span className="font-mono text-xs uppercase tracking-wider">Loading…</span>
                </div>
            </div>
        );
    }
    if (!user) return <Navigate to="/login" state={{ from: loc }} replace />;
    // Phase 8.0b: a non-impersonating platform admin has no tenant scope —
    // funnel them into the admin console so they don't accidentally land
    // on an empty tenant dashboard with role="platform_admin".
    if (user.is_platform_admin && !user.impersonated_by && !loc.pathname.startsWith("/admin")) {
        return <Navigate to="/admin" replace />;
    }
    return children;
}

export function PermissionGate({ permissions, anyOf, fallback = null, children }) {
    if (!anyOf || anyOf.length === 0) return children;
    const ok = anyOf.some((p) => permissions?.includes(p));
    if (!ok) return fallback;
    return children;
}
